/* eslint-disable react-hooks/exhaustive-deps */
import { connect } from 'react-redux';
import { Box } from '@material-ui/core';
import { getTableauReportingUrl, GET_TABLEAU_REPORTING_URL_SUCCESS } from '../dashboard/dashboard.actions';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
//import TableauReport from 'tableau-react-embed';
import useResizeAware from 'react-resize-aware';

import { getSelectedClientInformation, getSelectedDivisions } from 'utilities/authUtils';

import FullscreenSpinner from 'common/fullscreenSpinner.component';
import TableauErrorPage from './tableauErrorPage.component';

//const TABLEAU_REFRESH_INTERVAL_IN_SECONDS = 30 * 60;
const TABLEAU_LOAD_TIMEOUT = 30000;

const withTimeout = (promise, timeout, message) => {
  let timeoutId;
  const timeoutPromise = new Promise((resolve, reject) => {
    timeoutId = setTimeout(() => reject(new Error(message)), timeout);
  });

  return Promise.race([promise, timeoutPromise]).then(
    (result) => {
      clearTimeout(timeoutId);
      return result;
    },
    (error) => {
      clearTimeout(timeoutId);
      throw error;
    },
  );
};

const TableauReportWrapper = (props) => {
  const { reportPath, reportParameters, isSamsung } = props;

  const targetRef = useRef();
  const tableauRef = useRef();
  const [ sizes] = useResizeAware();
  
  const [reportUrl, setReportUrl] = useState(null);
  const [reportToken, setReportToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedClient, setSelectedClient] = useState(true);
  const [selectedDivisions, setSelectedDivisions] = useState([]);
  const [tableauError, setTableauError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    if (!reportUrl) {
      (async () => {
        try {
          const client = getSelectedClientInformation();
          const divisions = getSelectedDivisions();
          const response = await withTimeout(
            props.getTableauReportingUrl(reportPath),
            TABLEAU_LOAD_TIMEOUT,
            'Timed out retrieving Tableau report URL',
          );
          const responseData = response && response.response ? response.response : {};
          const resolvedReportUrl = responseData.reportUrl || responseData.ReportUrl;
          const resolvedReportToken = responseData.reportToken || responseData.ReportToken;

          if (window.customElements && window.customElements.whenDefined) {
            await withTimeout(
              window.customElements.whenDefined('tableau-viz'),
              TABLEAU_LOAD_TIMEOUT,
              'Timed out waiting for Tableau Embedding API',
            );
          }

          if (!isMounted) return;

          setSelectedClient(client);
          setSelectedDivisions(divisions);

          if (response.type === GET_TABLEAU_REPORTING_URL_SUCCESS && resolvedReportUrl && resolvedReportToken){
            setReportToken(resolvedReportToken);
            setReportUrl(resolvedReportUrl);
          } else {
            setTableauError(true);
          }
        } catch (error) {
          if (isMounted) {
            setTableauError(true);
          }
        } finally {
          if (isMounted) {
            setIsLoading(false);
          }
        }
      })();
    }

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (!reportUrl || !reportToken || !tableauRef.current) return undefined;

    const tableauViz = tableauRef.current;
    const handleTableauLoaded = () => clearTimeout(timeoutId);
    const handleTableauError = () => {
      clearTimeout(timeoutId);
      setTableauError(true);
    };
    const timeoutId = setTimeout(() => setTableauError(true), TABLEAU_LOAD_TIMEOUT);

    tableauViz.addEventListener('firstinteractive', handleTableauLoaded);
    tableauViz.addEventListener('load', handleTableauLoaded);
    tableauViz.addEventListener('vizloaderror', handleTableauError);
    tableauViz.addEventListener('error', handleTableauError);

    return () => {
      clearTimeout(timeoutId);
      tableauViz.removeEventListener('firstinteractive', handleTableauLoaded);
      tableauViz.removeEventListener('load', handleTableauLoaded);
      tableauViz.removeEventListener('vizloaderror', handleTableauError);
      tableauViz.removeEventListener('error', handleTableauError);
    };
  }, [reportUrl, reportToken]);

  console.log('rerender');
  return (
    <Box ref={targetRef} position="relative" height={isSamsung ? "501px" : "100%"}>
      {
        tableauError ? (<TableauErrorPage /> ) :
          isLoading || !reportUrl? 
            <FullscreenSpinner /> : 

            <tableau-viz id="tableauViz"
              ref={tableauRef}
              src={reportUrl}
              token={reportToken}
              height={isSamsung ? 501 : (sizes.height < 750 ? 750: sizes.height)} 
              width="100%"
              style={{ display: 'block', width: '100%' }}
              toolbar="hidden" 
              hide-tabs="true" 
              hide-edit-button="true" 
              hide-edit-in-desktop-button="true" 
              suppress-default-edit-behavior="true" 
              iframe-attr-loading="eager"
            >
              <viz-parameter name="Clientid" value={selectedClient.id}></viz-parameter>
              <viz-parameter name="Buscodekey1" value={selectedDivisions.join(',')}></viz-parameter>
              {reportParameters && Object.keys(reportParameters).map(key => {
                return (<viz-parameter key={key} name={key} value={reportParameters[key]}></viz-parameter>);
              })}
            </tableau-viz>
            // <TableauReport
            //   url={reportUrl}
            //   token={reportToken}
            //   options={{
            //     height: sizes.height < 750 ? 750: sizes.height,
            //     width: sizes.width,
            //     hideTabs: true,
            //     hideToolbar: false,
            //     toolbarPosition: 'TOP',
            //   }}
            //   refreshSeconds={TABLEAU_REFRESH_INTERVAL_IN_SECONDS}
            //   parameters={{
            //     Clientid: selectedClient.id,
            //     Buscodekey1: selectedDivisions.join(','),
            //     ...(reportParameters ? reportParameters : null),
            //   } 
            //   }
            // />
      }
    </Box>
  );
};

TableauReportWrapper.propTypes = {
  reportPath: PropTypes.string.isRequired,
  reportParameters: PropTypes.object,
};

export default withRouter(
  connect(null, {
    getTableauReportingUrl,
  })(TableauReportWrapper),
);
